import React from 'react';
import { Globe } from 'lucide-react';
import { useLang } from '../context/LangContext';

export const LangSwitcher = ({ className = '', compact = false }) => {
  const { lang, setLang, supported } = useLang();

  return (
    <div
      data-testid="lang-switcher"
      className={`inline-flex items-center gap-1 ${className}`}
    >
      {!compact && <Globe className="w-4 h-4 text-gray-500 mr-1" />}
      <div className="inline-flex items-center bg-gray-100 rounded-full p-0.5">
        {supported.map((opt) => {
          const isActive = lang === opt.code;
          return (
            <button
              key={opt.code}
              type="button"
              data-testid={`lang-pill-${opt.code}`}
              aria-label={`Switch language to ${opt.name}`}
              onClick={() => setLang(opt.code)}
              className={`px-2.5 py-1 text-xs font-semibold rounded-full transition ${
                isActive
                  ? 'bg-[#07743F] text-white shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LangSwitcher;
